export const CostCenterStatusLabel = {
  0: 'Activo',
  1: 'Inactivo',
}
